import Vue from 'vue'
import jwtDecode from 'jwt-decode'
// import Auth from './auth'
// import router from '../router/router'
// import { EventBus } from '../components/events/event-bus.js'

let API_URL = window.location.origin
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  API_URL = 'http://localhost:3000'
}

const $ = require('jquery')
const TAG = '[REST]'
let Rest = null
Rest = {
  baseURL: API_URL + '/api/v1',
  baseOfBaseUrl: API_URL,
    // Demo function. Add others when necessary
    /*
    demo () {
        return this.request('GET', '/endpoint/', null,
            Vue.vm.$auth.getToken(), null)
    },
    */

  /*
   * Does actual rest calls.
   * @param type request (HTTP) type.
   * @param endpoint endpoint to use
   * @param data data object
   * @param token access token
   * @param queryParams query (url) parameters
   * */
  request: function (type, endpoint, data, queryParams, token) {
    queryParams = queryParams || {}
    if (token != null) {
      queryParams.access_token = token
    }

    var req = $.param(queryParams)
    if (req) {
      req = '?' + req
    }
    // console.log(TAG, type + ' request to ' + endpoint + ' with data = ' + data + ' queryParams = ' + req)

    return new Promise(
      function (resolve, reject) {
        let tokenUsed = null
        let requestObj = {
          url: API_URL + '/api/v1' + endpoint + req,
          data: data ? JSON.stringify(data) : null,
          type: type, // POST, GET, PUT, DELETE
          dataType: 'json',
          contentType: 'application/json; charset=UTF-8',
          beforeSend: function (xhr) {
            if (Rest.Vue) {
              let acceptLanguage = Rest.Vue.$store.getters.getAcceptLanguage
              if (acceptLanguage != null) xhr.setRequestHeader('Accept-Language', acceptLanguage)
            }
            let accessToken = localStorage.getItem('sessionAccessToken')
            if (accessToken != null) {
              tokenUsed = 'sessionAccessToken'
              xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken)
            } else {
              let refreshToken = localStorage.getItem('sessionRefreshToken')
              if (refreshToken != null) {
                tokenUsed = 'sessionRefreshToken'
                xhr.setRequestHeader('Authorization', 'Bearer ' + refreshToken)
              }
            }
          }
        }

        let doneHandler = function (response, textStatus, xhr) {
          // console.log(response)

          try {
            // console.log(TAG, 'Request success, response = ' + response)

            // Check for JWT refresh and access tokens.
            let refreshToken = xhr.getResponseHeader('X-Auth-Refresh-Token')
            let accessToken = xhr.getResponseHeader('X-Auth-Access-Token')

            // Check if refresh token present.
            if (refreshToken != null) {
              localStorage.setItem('sessionRefreshToken', refreshToken)
            }

            // Check if access token present.
            if (accessToken != null) {
              localStorage.setItem('sessionAccessToken', accessToken)

              // TODO: update user permissions - use the roleIds to do it.
              let decoded = jwtDecode(accessToken)
              let roleIds = decoded.roles // array of role ids
              console.log('roleIds', roleIds)
            }

            resolve(response)
          } catch (e) {
            console.log(TAG, 'Failed to parse JSON, response = ' + response + ' exception = ' + e)
            reject(e)
          }
        }

        let failHandler = function (xhr, status, errorThrown, isRefreshError) {
          let errorKey = 'api_unavailable'
          // console.log(xhr)
          if (xhr.status !== 401 || (!Rest.Vue.$store.state.is401ToastShown && isRefreshError)) {
            if (errorThrown === 'Unauthorized') {
              Rest.Vue.$snotify.error(Rest.Vue.$t('errors.unauthorizedMessage'), Rest.Vue.$t('errors.unauthorized'))
            } else {
              Rest.Vue.$snotify.error(xhr.responseJSON.message, errorThrown)
            }
          }
          switch (xhr.status) {
              // TODO add other codes
            case 400:
              errorKey = 'bad_request'
              break
            case 401:
              errorKey = 'unauthorized'

              // prevent multiple invalid token toasts - set the flag for 3 seconds
              if (isRefreshError) {
                Rest.Vue.$store.commit('set401ToastShown', true)
                setTimeout(() => {
                  Rest.Vue.$store.commit('set401ToastShown', false)
                }, 3000)
              }
              // Invalidate the JWT token that was used.
              if (tokenUsed != null) {
                localStorage.removeItem(tokenUsed)
                Rest.Vue.$store.commit('updateLoginStatus', 'You don\'t have permission to view this resource!') // TODO: translate
                // If token used was access token then retry the request (with refresh token).
                if (tokenUsed === 'sessionAccessToken') {
                  $.ajax(requestObj).done(doneHandler).fail((...args) => failHandler(...args, true))
                  return
                } else {
                  // sent refresh token and recieved invalid status
                  Rest.Vue.$store.commit('updateUserData', '')
                }
              }

              break
            case 403:
              errorKey = 'forbidden'
              break
            case 500:
              errorKey = 'internal_server_error'
              break
          }

          console.log(TAG, 'Request failed, reason = ' + errorKey)

          // Redirect to login
          if (errorKey === 'unauthorized') {
            Vue.vm.$router.push({name: 'home'})
          } else {
            reject(xhr)
          }

          // TODO show alert (when components are imported)

          // reject(xhr)
        }

        // Send the request.
        $.ajax(requestObj).done(doneHandler).fail(failHandler)
      })
  },
  requestForm: function (type, endpoint, data, queryParams, token) {
    queryParams = queryParams || {}
    if (token != null) {
      queryParams.access_token = token
    }
    var req = $.param(queryParams)
    if (req) {
      req = '?' + req
    }
    console.log(TAG, type + ' request to ' + endpoint + ' with data = ' + data + ' queryParams = ' + req)
    return new Promise(
      function (resolve, reject) {
        let tokenUsed = null
        let requestObj = {
          url: API_URL + '/api/v1' + endpoint + req,
          data: data,
          type: type, // POST, GET, PUT, DELETE
          contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
          processData: false, // NEEDED, DON'T OMIT THIS
          cache: false,
          beforeSend: function (xhr) {
            let accessToken = localStorage.getItem('sessionAccessToken')
            if (accessToken != null) {
              tokenUsed = 'sessionAccessToken'
              xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken)
            } else {
              let refreshToken = localStorage.getItem('sessionRefreshToken')
              if (refreshToken != null) {
                tokenUsed = 'sessionRefreshToken'
                xhr.setRequestHeader('Authorization', 'Bearer ' + refreshToken)
              }
            }
          }
        }
        let doneHandler = function (response, textStatus, xhr) {
          console.log(response)
          try {
            console.log(TAG, 'Request success, response = ' + response)
            // Check for JWT refresh and access tokens.
            let refreshToken = xhr.getResponseHeader('X-Auth-Refresh-Token')
            let accessToken = xhr.getResponseHeader('X-Auth-Access-Token')
            // Check if refresh token present.
            if (refreshToken != null) {
              localStorage.setItem('sessionRefreshToken', refreshToken)
            }
            // Check if access token present.
            if (accessToken != null) {
              localStorage.setItem('sessionAccessToken', accessToken)
              // TODO: update user permissions - use the roleIds to do it.
              let decoded = jwtDecode(accessToken)
              let roleIds = decoded.roles // array of role ids
              console.log('roleIds', roleIds)
            }
            resolve(response)
          } catch (e) {
            console.log(TAG, 'Failed to parse JSON, response = ' + response + ' exception = ' + e)
            reject(e)
          }
        }

        let failHandler = function (xhr, status, errorThrown) {
          let errorKey = 'api_unavailable'

          switch (xhr.status) {
              // TODO add other codes
            case 400:
              errorKey = 'bad_request'
              break
            case 401:
              errorKey = 'unauthorized'
              // Invalidate the JWT token that was used.
              if (tokenUsed != null) {
                localStorage.removeItem(tokenUsed)
                Rest.Vue.$store.commit('updateUserData', '')
                Rest.Vue.$store.commit('updateLoginStatus', 'You don\'t have permission to view this resource!') // TODO: translate
                // If token used was access token then retry the request (with refresh token).
                if (tokenUsed === 'sessionAccessToken') {
                  $.ajax(requestObj).done(doneHandler).fail(failHandler)
                  return
                }
              }

              break
            case 403:
              errorKey = 'forbidden'
              break
            case 500:
              errorKey = 'internal_server_error'
              break
          }

          console.log(TAG, 'Request failed, reason = ' + errorKey)

          // Redirect to login
          if (errorKey === 'unauthorized') {
            Vue.vm.$router.push({name: 'home'})
          } else {
            reject(xhr)
          }

          // TODO show alert (when components are imported)

          // reject(xhr)
        }

        // Send the request.
        $.ajax(requestObj).done(doneHandler).fail(failHandler)
      })
  }
}

Rest.install = function install (Vue) {
  Vue.prototype.$rest = Rest
}

export default Rest

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Rest)
}



// WEBPACK FOOTER //
// ./src/services/rest.js